import React from 'react';
import { connect } from 'react-redux';
import { DBIntFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestHipLegLength extends React.Component {

    render() {
        return(
            <div key={this.props.panelId} className={styles.dropdown_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Leg Length'/>
                <span className={styles.spacer} />
                <label className={styles.label}>Leg Length</label>
                <DBIntFieldObjective
                    field='TSHIPLEGLENR'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.r}
                    min={0}
                />
                <span className={styles.c} />
                <DBIntFieldObjective
                    field='TSHIPLEGLENL'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.l}
                    min={0}
                    />
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: 
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSHIPLEGLENR && 
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSHIPLEGLENL &&
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSHIPLEGLENR !==
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSHIPLEGLENL
            ? true : false,
    };
}

const connectedSpecialTestHipLegLength = connect(mapStateToProps)(SpecialTestHipLegLength);
export { connectedSpecialTestHipLegLength as SpecialTestHipLegLength };



